import { render, staticRenderFns } from "./HistoryCode.vue?vue&type=template&id=5c321006"
import script from "./HistoryCode.vue?vue&type=script&lang=js"
export * from "./HistoryCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports